import React, {useEffect, useRef, useState} from 'react';

import ReactCrop, {
  Crop,
  PixelCrop,
  centerCrop,
  makeAspectCrop,
} from 'react-image-crop';
import {toast} from 'react-toastify';

import {useDebounceEffect} from '../../utilities/hooks/imageCropper/useDebounceEffect';
import {canvasPreview} from '../../utilities/hooks/imageCropper/canvasPreview';
import CustomButton from '../mazraeKit/customButton';

interface CroppingImageProps {
  imageFile: File | null;
  navigateControll?: () => void;
  addingCropedImageDispatcher: (event: File) => void;
  clearImageDispatcher: () => void;
}
const CroppingImage = ({
  imageFile,
  addingCropedImageDispatcher,
  clearImageDispatcher,
  navigateControll,
}: CroppingImageProps) => {
  const imgRef = useRef<HTMLImageElement>(null);
  const previewCanvasRef = useRef<HTMLCanvasElement>(null);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [imgSrc, setImgSrc] = useState('');
  const [crop, setCrop] = useState<Crop>();
  const [completedCrop, setCompletedCrop] = useState<PixelCrop>();

  function onSelectFile(e: File) {
    if (e) {
      setCrop(undefined);
      const reader = new FileReader();
      reader.addEventListener('load', () =>
        setImgSrc(reader.result?.toString() || ''),
      );
      reader.readAsDataURL(e);
    }
  }
  useEffect(() => {
    imageFile && onSelectFile(imageFile);
  }, [imageFile]);

  useDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
        canvasPreview(imgRef.current, previewCanvasRef.current, completedCrop);
      }
    },
    100,
    [completedCrop],
  );
  function onImageLoad(e: React.SyntheticEvent<HTMLImageElement>) {
    const {width, height} = e.currentTarget;
    setCrop(centerAspectCrop(width, height, 1));
  }

  async function onDownloadCropClick() {
    setIsLoading(true);

    if (!previewCanvasRef.current) {
      throw new Error('Crop canvas does not exist');
    }

    previewCanvasRef?.current.toBlob(blob => {
      if (!blob) {
        toast.error('مشکلی در آپلود عکس پیش آمده.');
      } else {
        if (imageFile) {
          const file = new File([blob], imageFile.name, {
            type: imageFile.type,
          });

          addingCropedImageDispatcher(file);
          clearImageDispatcher();
          navigateControll && navigateControll();
        }
      }
      setIsLoading(false);
    });
  }
  return (
    <div className="d-flex w-full h-full flex-col justify-between">
      <div className="w-full ReactCrop__child-wrapper-image-cropper flex">
        {!!imgSrc && (
          <ReactCrop
            className="h-full w-full"
            crop={crop}
            onChange={(_, percentCrop) => setCrop(percentCrop)}
            onComplete={c => setCompletedCrop(c)}
          >
            <img
              className="h-full"
              ref={imgRef}
              alt="Crop me"
              src={imgSrc}
              onLoad={onImageLoad}
            />
          </ReactCrop>
        )}
        {!!completedCrop && (
          <>
            <div className=" d-none">
              <canvas
                ref={previewCanvasRef}
                style={{
                  border: '1px solid black',
                  objectFit: 'contain',
                  width: completedCrop.width,
                  height: completedCrop.height,
                }}
              />
            </div>
          </>
        )}
      </div>
      <div className="d-flex gap-2 px-2  w-full items-center rounded-t-[8px] text-md font-Medium h-[64px] shadow-dropShadow">
        <CustomButton
          disabled={isLoading}
          onClick={() => {
            onDownloadCropClick();
          }}
          type="button"
          title="انتخاب تصویر"
          isLoading={isLoading}
          className="bg-farm-shop-500 w-[50%] text-white h-[48px] flex rounded-[8px] items-center justify-center border border-farm-shop-500"
        />
        <CustomButton
          onClick={() => {
            navigateControll && navigateControll();
            clearImageDispatcher();
          }}
          type="submit"
          title="انصراف"
          isLoading={false}
          className="text-farm-shop-500 w-[50%] h-[48px] flex items-center justify-center rounded-[8px] border border-farm-shop-500"
        />
      </div>
    </div>
  );
};

export default CroppingImage;
function centerAspectCrop(
  mediaWidth: number,
  mediaHeight: number,
  aspect: number,
) {
  return centerCrop(
    makeAspectCrop(
      {
        unit: '%',
        width: 90,
      },
      aspect,
      mediaWidth,
      mediaHeight,
    ),
    mediaWidth,
    mediaHeight,
  );
}
